export { HighlightedText as default } from '@disco/shared-components/ui/highlighted-text'
